import { render, staticRenderFns } from "./uploadPic.vue?vue&type=template&id=669beeac"
import script from "./uploadPic.vue?vue&type=script&lang=js"
export * from "./uploadPic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports